import React from 'react';
import { PublicContentPage } from './PublicContentPage';

export function UserReviewsPage() {
  return <PublicContentPage type="reviews" title="ইউজার রিভিউ" />;
}
